import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { Link as RouteLink } from 'react-router-dom'
import { routes } from 'config'
import {
  ErrorBoundary,
  ModuleHeader,
  CustomFade,
  CustomAlert,
  ButtonContainer,
} from '../'

// TODO: Giving error with JSX.Element
interface IProps {
  isModuleInitialized?: boolean
  serviceError?: string
  children?: any
}

const Module: FC<IProps> = ({
  isModuleInitialized,
  serviceError,
  children,
}) => {
  const isModuleInitializing: boolean = Boolean(
    !isModuleInitialized && !serviceError,
  )
  const isErrorOccurredWhileModuleInitialization: boolean = Boolean(
    !isModuleInitialized && serviceError,
  )

  const moduleHeaderProps =
    Array.isArray(children) && children?.filter((v: any) => v?.props?.title)[0]
  const headerTitle = moduleHeaderProps?.props?.title
  const headerClassName = moduleHeaderProps?.props?.className

  if (isModuleInitializing) {
    return <ModuleHeader title={headerTitle} className={headerClassName} />
  } else if (isErrorOccurredWhileModuleInitialization) {
    return (
      <ModuleHeader title={headerTitle} className={headerClassName}>
        <CustomAlert severity="error">{serviceError}</CustomAlert>
        <ButtonContainer
          secondary={<RouteLink to={routes.login}>Return To Login</RouteLink>}
        />
      </ModuleHeader>
    )
  }

  return isModuleInitialized && children ? (
    <ErrorBoundary>
      <Grid container direction="column">
        <CustomFade>{children}</CustomFade>
      </Grid>
    </ErrorBoundary>
  ) : null
}

Module.defaultProps = {
  isModuleInitialized: true,
}

export default Module
